export default __webpack_public_path__ + "static/media/shrewdblow4.8e3eb578.png";